import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
// import {ItemsGroup} from "../../views/setting/usersGroups/usersGroups";
import {User} from "../../model";
import {UserService} from "../../services/user.service";
import {Message} from "primeng/api";

@Component({
    selector: 'app-user-profile',
    templateUrl: './record-data.component.html',
    styleUrls: ['./record-data.component.scss'],
    providers: []
})
export class RecordDataComponent implements OnInit {
    id: string;
    //filter: any;
    public user: User;
    userData: any;
    public logs: Log[];

    msgs: Message[] = [];
    @Input() rowId;
    @Input() refRec: any;
    @Input() refShow;
    behalf:string;
    modalRef: NgbModalRef;
    form: FormGroup;
    sts:string;
    sync_sts:string;
    rec_sts:string;


    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private userService: UserService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;
            // this.oldPass = userdata.password;
        }
      /*  const filter = JSON.parse(localStorage.getItem('filter'));
        if(filter){
            this.filter = filter;
        }*/


    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            id: new FormControl({value: '', disabled: true}),
            creation_user: new FormControl({value: '', disabled: true}),
            creation_ip: new FormControl({value: '', disabled: true}),
            creation_date: new FormControl({value: '', disabled: true}),
            update_date: new FormControl({value: '', disabled: true}),
            trans_status: new FormControl({value: '', disabled: true}),
            last_update_user: new FormControl({value: '', disabled: true}),
            last_update_ip: new FormControl({value: '', disabled: true}),
            on_behalf: new FormControl({value: '', disabled: true}),
            last_on_behalf: new FormControl({value: '', disabled: true}),
            sync_state: new FormControl({value: '', disabled: true}),
            sync_date: new FormControl({value: '', disabled: true}),
            rec_id: new FormControl({value: '', disabled: true}),
            rec_sts: new FormControl({value: '', disabled: true}),

        });
        //localStorage.removeItem('filter');
        /*  const msg = JSON.parse(localStorage.getItem('showMessages'));
          if (msg) {
              localStorage.removeItem('showMessages');
              this.msgs = msg;
          }*/
        this.userService.getById(this.refRec.creation_user).subscribe(
            user => {
                this.form.controls['last_update_user'].setValue('('+ user.id +') -- '+user.name);
            }
        );
        this.userService.getById(this.refRec.creation_user).subscribe(
            user => {
                this.form.controls['creation_user'].setValue(user.name);
            }
        );
        this.userService.getById(this.refRec.on_behalf_of).subscribe(
            user=>{
                this.form.controls['on_behalf'].setValue('('+ user.id +') -- '+user.name);
            }
        );
        this.userService.getById(this.refRec.last_on_behalf_of).subscribe(
            user=>{

                this.form.controls['last_on_behalf'].setValue('('+ user.id+') -- '+user.name);

            }
        );
        if (this.refRec) {
            // this.id = this.refRec.id;

            let rec = this.refRec;
            this.refRec = rec;
            if(rec.trans_status == 1){
                this.sts="Not Accredited";
            }else if(rec.trans_status ==2){
                this.sts="Accredited";
            }
            if(rec.synce_status == 0){
                this.sync_sts ='Not synchronized';
            }else if(rec.synce_status ==1){
                this.sync_sts ='Has been synchronized';
            }
            if(rec.status==0){
                this.rec_sts="Active";
            }else if(rec.status){
                this.rec_sts="Inactive";
            }
            this.form.patchValue({
                id: rec.row_id,
               // creation_user: this.userName,
                creation_ip: rec.creation_ip,
                creation_date: rec.created_at,
                update_date: rec.updated_at,
                trans_status:this.sts,
                // last_update_user:rec.last_update_user,
                last_update_ip:rec.last_update_ip,
                sync_date:rec.synce_timestamp,
                rec_id:rec.id,

                // on_behalf:this.behalf,
                // last_on_behalf:this.behalf,


            });
        }else {
            console.log(this.refRec);
        }
    }

    onSubmit() {

    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    close() {
        this.activeModal.dismiss('done');
    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/record-data/record-data.component.ts